(ns app.domain.complaint.model
  (:require [app.domain.file.model :as file-model]
            [app.domain.group.config.model :as config-model]
            [app.domain.group.model :as group-model]
            [app.i18n.model :as i18n-model]
            [cloudpermit-commons.schemas.general :as general]
            [core.db.child-entity :as child]
            [core.util.schemas :as schemas]
            [schema-tools.core :as st]
            [schema.core :as s]))


(def allowed-amount-of-images 20)

(def complaint-states [:complaint.state/open
                       :complaint.state/reviewed
                       :complaint.state/abandoned])

(def editable-states
  #{:complaint.state/open
    :complaint.state/abandoned})

(defn editable? [{:domain/keys [state]}]
  (contains? editable-states state))


(def internal-sources
  "Complaint sources owned and managed by the system"
  #{:complaint.source/cloudpermit})


(defn source-change-allowed?
  [{:complaint/keys [source]}]
  (nil? source))


(def complaint-contact-fields [:complaint/complainer-name
                               :complaint/complainer-address
                               :complaint/complainer-phone
                               :complaint/complainer-email])

(def complaint-edit-keys
  (concat [:domain/state
           :complaint/category-group-config
           :complaint/description
           :complaint/description-of-location
           :complaint/severity
           :complaint/response-requested?
           :complaint/external-source]
          complaint-contact-fields))

(def severity-order
  "Numeric ordering for severity levels (inverted from config-model/complaint-severity).
  Lower numbers represent higher severity for use with < comparator in sorts.
  #:complaint-severity {:emergency 0, :high 1, :standard 2, :low 3}"
  (zipmap (reverse config-model/complaint-severity)
          (range)))


(s/defschema ComplaintPhoto
  {:file/filename     s/Str
   :file/category     file-model/FileCategory
   :file/md5          s/Str
   :file/content-type s/Str})

(s/defschema Complaint
  (st/merge {:complaint/description           general/NonBlankString
             :complaint/category-group-config s/Int}
            (st/optional-keys {:complaint/description-of-location general/NonBlankString
                               :complaint/external-source         (s/cond-pre s/Int s/Str)
                               :complaint/signed-at               s/Inst
                               :complaint/response-requested?     s/Bool
                               :complaint/complainer-name         general/NonBlankString
                               :complaint/severity                (apply s/enum config-model/complaint-severity)
                               :complaint/complainer-address      general/NonBlankString
                               :complaint/complainer-phone        general/NonBlankString
                               :complaint/complainer-email        schemas/Email
                               :complaint/photos                  [{:file-id s/Str
                                                                    :file    ComplaintPhoto}]})))

(s/defschema UIComplaint
  (st/merge Complaint
            (st/optional-keys {:complaint/complainer-email schemas/UserInputEmail})))


(s/defschema ComplaintContactInformation (apply s/enum complaint-contact-fields))



(defn make-ui-checker [required-contact-fields]
  (s/checker (st/required-keys UIComplaint (vec required-contact-fields))))


(def dashboard-filter-condition-attributes
  [:complaint/category-names
   :domain/state])


(def record-search-filter-condition-attributes
  [:permit-type
   :complaint/category-names
   :domain/state])


(def search-sort-attributes
  [:created
   :modified])


(s/defschema ComplaintSearchSorting
  [(s/one (apply s/enum search-sort-attributes) "attribute")
   (s/one (s/enum :asc :desc) "direction")])


(defn category-name [complaint lang]
  (some-> complaint
          :complaint/category-group-config
          (config-model/localized-name lang)))


(defn full-address
  "Format a full address string from address components."
  ([complaint]
   (or
     (some-> complaint :complaint/property :property/primary-address :address/full-address)
     (some-> complaint :complaint/address))))


(def ^{:arglists '([complaint-source lang])} complaint-source-label
  (i18n-model/translation-fallback-fn :complaint-source/names))


(defmethod i18n-model/get-localized-string-attrs :entity.type/complaint-source
  [_]
  [:complaint-source/names])

(defmethod i18n-model/get-localized-string-attrs :entity.type/complaint-severity-config
  [_]
  [:complaint-severity-config/help-texts])

(defmethod group-model/get-authority-group :entity.type/complaint-source
  [entity]
  (:domain/authority-group entity))


(defmethod group-model/get-authority-group :entity.type/complaint
  [entity]
  (:domain/authority-group entity))




(defn complaint-photos [complaint]
  (->> complaint
       file-model/file-children
       (filter (file-model/category-is-fn :file.category/complaint-photo))))


(def ^{:arglists '([ws-entity])} workspace-complaints
  (child/child-entities-of-type-fn :entity.type/complaint))

(defn complaint-permit-type [complaint]
  (-> complaint
      :complaint/category-group-config
      :entity/parent
      :group.config/target))
